import React from "react";

export default function VideoItem(props) {
  return (
    <video width={"100%"} height={280} controls controlsList="nodownload">
      <source src={props.url} type="video/mp4" />
    </video>
  );
}
